<script>
    import { getContext, setContext, createEventDispatcher } from 'svelte'
    import * as L from 'leaflet'
    import 'leaflet/dist/leaflet.css'

    export let centre = [51.505, -0.09]
    export let zoom = 4
    export let maxZoom = 14
    export let minZoom = 3
    export let map = null

    const { mapboxAccessToken: accessToken } = getContext('config')
    const MAPBOX_API_BASE_URL = 'https://api.mapbox.com/styles/v1/mapbox/{style}/tiles/{z}/{x}/{y}?access_token={accessToken}'
    const MAPBOX_SATELLITE_STREETS_TILE_OPTIONS = {
        style: 'satellite-streets-v11',
        accessToken,
        tileSize: 512,
        zoomOffset: -1,
        maxZoom, minZoom,
        keepBuffer: 32
    }

    const tileLayerUrl = MAPBOX_API_BASE_URL
    const tileLayerOptions = MAPBOX_SATELLITE_STREETS_TILE_OPTIONS
    const mapOptions = {
        wheelPxPerZoomLevel: 80
    }

    const dispatch = createEventDispatcher()

    setContext('map', {
    	getMap: () => map,
      paddedRenderer: L.svg({ padding: 2 })
    })

    function createMap(container) {
        let newMap = L.map(container, mapOptions).setView(centre, zoom)
        L.tileLayer(tileLayerUrl, tileLayerOptions).addTo(newMap)

        return newMap
    }

    function mapAction(container) {
        map = createMap(container)
        map.on('zoomstart', () => dispatch('zoomstart', map.getZoom()))
        map.on('zoomend', () => dispatch('zoom', map.getZoom()))

        return {
            destroy: () => {
                map.remove()
            },
        }
    }
</script>

<div class="map-container" use:mapAction>
	{#if map}
		<slot></slot>
	{/if}
</div>

<style>
    .map-container {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>
